export class GridRow<TData> {
  uuid!: string;
  isChecked: boolean = false;
  isRowExpanded: boolean = false;
  isDisabledAccordionButton: boolean = false;
  data!: TData;
}
